import { render, staticRenderFns } from "./GrossProfitMTD.vue?vue&type=template&id=648d787f&scoped=true"
import script from "./GrossProfitMTD.vue?vue&type=script&lang=js"
export * from "./GrossProfitMTD.vue?vue&type=script&lang=js"
import style0 from "./GrossProfitMTD.vue?vue&type=style&index=0&id=648d787f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648d787f",
  null
  
)

export default component.exports